import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckTickSquare = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.66667 8.34157L7.22746 9.9007C7.97815 8.58806 9.01704 7.46296 10.2658 6.61024L10.3333 6.56413M8 14C6.13623 14 5.20435 14 4.46927 13.6955C3.48915 13.2895 2.71046 12.5108 2.30448 11.5307C2 10.7956 2 9.86377 2 8C2 6.13623 2 5.20435 2.30448 4.46927C2.71046 3.48915 3.48915 2.71046 4.46927 2.30448C5.20435 2 6.13623 2 8 2C9.86377 2 10.7956 2 11.5307 2.30448C12.5108 2.71046 13.2895 3.48915 13.6955 4.46927C14 5.20435 14 6.13623 14 8C14 9.86377 14 10.7956 13.6955 11.5307C13.2895 12.5108 12.5108 13.2895 11.5307 13.6955C10.7956 14 9.86377 14 8 14Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCheckTickSquare);
export default ForwardRef;
